<template>
  <div>
    <div class="cruisePortsBar" @click="openCruisePortsModal">
      <div class="lbl">航程详情</div>
      <img class="icon" :src="`${imgUrl}/global/icons/iconArrowRightBlueMiniMB.png`" alt="" />
    </div>
    <div class="rcclPopover" :style="show()">
      <div class="yellowTip-m">
        <div class="cruisePortsModalHeader">航程详情</div>
        <div class="cruisePortsModal">
          <div class="cruisePortsModalScroll">
            <div  class="cruisePortsModalContent">
              <div class='cruisePortsItem' v-for="(item, index) in list" :key="index">
                <div class="cruisePortsItemHeader">
                  <div class='cruisePortsItemIcon' :style="{'background':item.iconColor}">
                    <img class='iconImg' :src="item.iconImg" alt="" />
                  </div>
                  <div class="cruisePortsItemBase">
                    <div>第{{item.day}}天</div>
                    <div class="divideLine"></div>
                    <div>{{item.portDay}}</div>
                    <div class="divideLine"></div>
                    <div><span v-if="item.activity === 'DOCKED' && item.countryName">{{item.countryName}}·</span>{{item.title}}</div>
                  </div>
                </div>
                <!--码头地址-->
                <template v-if="item.showPortAddress && item.address">
                  <div class='cruisePortsItemPortAddress'>码头地址：{{item.address}}</div>
                </template>
                <!--港口-->
                <template v-if="item.activity === 'DOCKED'">
                  <div v-if="item.arrivalTime || item.departureTime" class='cruisePortsItemArrivalTime'>
                    <span v-if="item.arrivalTime">{{item.arrivalTime ? '抵港 ' + item.arrivalTimeStr : ''}}</span>
                    <span v-if="item.departureTime">{{item.departureTime ? '启航 ' + item.departureTimeStr : ''}}</span>
                  </div>
                  <template v-if="item.address">
                    <div class='cruisePortsItemPortAddress'>码头地址：{{item.address}}</div>
                  </template>
                </template>
              </div>
              <div class="cruisePortsDesc">起航/抵港时间、停靠港及行程可能因特殊情况发生调整，请以实际运营为准。</div>
            </div>
          </div>
        </div>
        <div class="cruisePortsModalBtn" data-popupname="yellowTip" @click="submit">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/api'
export default {
  name: "CruisePortsPopup",
  props: {
    isSale: {
      type: Boolean,
      default: false
    },
    shipCode: {
      type: String,
      default: ''
    },
    sailDate: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      isShow: false,
      list: [],
      imgUrl: process.env.VUE_APP_IMG_URL,
      logoImgUrl: process.env.VUE_APP_LOGO_IMG_URL
    }
  },
  methods: {
    show() {
      return this.isShow ? { 'display': 'block'} : { 'display': 'none' }
    },
    openCruisePortsModal() {
      if(this.isSale) {
        this.$router.push(`/Rccl.Cruise/CruiseDetail?shipCode=${this.shipCode}&sailDate=${this.sailDate}`)
      } else {
        this.open()
      }
    },
    async open() {
      this.$loading.show()
      const {success, data, errMsg} = await api.booking.getCruisePortsDetail({
        shipCode: this.shipCode,
        sailDate: this.sailDate,
        source: 'mobile'
      })
      this.$loading.hide()
      if (success) {
        this.list = this.formatRows(data);
        this.isShow = true
      } else {
        console.error(errMsg)
      }
    },
    close () {
      this.isShow = false
    },
    submit() {
      this.close();
    },
    formatRows(rows) {
      rows && rows.forEach((row)=> {
        let code = row.code;
        let title = ""
        if (code && code.indexOf("CRU") >= 0) {
          title = "海上巡航"
        } else {
          if (row.activity === "EMBARK" || row.activity === "DEBARK") {
            title += row.harborCNName
          } else {
            title += row.name
          }
        }
        row.title = title;

        row.arrivalTimeStr = row.arrivalTime && row.arrivalTime.substring(0, 5);
        row.departureTimeStr = row.departureTime && row.departureTime.substring(0, 5);
        row.showPortAddress = !(code && code.indexOf("CRU") >= 0) && (row.activity === 'EMBARK' || row.activity === 'DEBARK');
        row.showDescription = code && code.indexOf("CRU") >= 0;

        console.log(row.activity)
        if (row.activity === 'EMBARK') {
          row.iconImg = this.logoImgUrl + '/logoAnchorWhite.png';
        } else if (row.activity === 'DOCKED') {
          row.iconImg = this.imgUrl + '/global/icons/iconFlag.png';
        } else {
          row.iconImg = this.imgUrl + '/global/icons/iconShip.png';
        }

        switch(row.activity) {
          case 'CRUISING':
            row.iconColor = '#ED9100';
            break;
          case 'DOCKED':
            row.iconColor = '#46A91A';
            break;
          case 'EMBARK':
            row.iconColor = '#001770';
            break;
          default:
            row.iconColor = '#0068b3'
        }
      });
      return rows;
    }
  }
}
</script>

<style scoped lang="less">
.cruisePortsBar {
  display: flex;
  align-items: center;
  gap: 0 3px;
  font-family: PingFangSC, PingFang SC;
  & .lbl {
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    color: #4A90E2;
  }
  & .icon {
    height: 10px;
    width: 6px;
  }
}
.cruisePortsModal {
  font-family: PingFangSC, PingFang SC;
  background-color: #fff;
}
.cruisePortsModalHeader {
  margin: 0 19px;
  padding: 12px 0 10px;
  font-weight: 600;
  font-size: 16px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  box-sizing: content-box !important;
  color: #282828;
  border-bottom: 1px solid #eee;
}
.cruisePortsModalScroll {
  box-sizing: border-box;
  max-height: 424px;
  //padding: 10px 0;
  overflow-x: hidden;
  overflow-y: auto;
  //background-color: #fff;
}
.cruisePortsModalContent {
  padding: 10px 16px;
}
.cruisePortsModalBtn {
  width: 327px;
  height: 40px;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
  line-height: 40px;
  text-align: center;
  background: linear-gradient( 225deg, #FFDB17 0%, #FCBF00 100%);
}
.cruisePortsItem {
  padding: 9px 13px;
  border-radius: 5px;
  background: #F4FBFF;
  &+.cruisePortsItem {
    margin-top: 10px;
  }
}
.cruisePortsItemHeader {
  position: relative;
  display: flex;
  height: 21px;
}
.cruisePortsItemIcon {
  width: 21px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 21px;
  position: relative;
  & .iconImg {
    display: block;
    height: 14px !important;
  }
}
.cruisePortsItemBase {
  display: flex;
  gap: 9px;
  font-size: 14px;
  font-weight: 400;
  color: #282828;
  line-height: 21px;
  & .divideLine {
    width: 1px;
    height: 11px;
    margin-top: 5px;
    background-color: #8f9295;
  }
}
.cruisePortsItemArrivalTime {
  font-size: 11px;
  margin-top: 6px;
  line-height: 16px;
  & span {
    margin-right: 10px;
  }
}

.cruisePortsItemPortAddress {
  font-size: 11px;
  margin-top: 6px;
  line-height: 16px;
  color: #9B9B9B;
}
.cruisePortsDesc {
  font-family: PingFangSC, PingFang SC;
  width: 100%;
  font-weight: 400;
  font-size: 10px;
  color: #9E9F9E;
  line-height: 14px;
  margin-top: 10px;
  padding-bottom: 14px;
}
.yellowTip-m {
  width: 327px;
  padding-top: 0;
}
.yellowTip-txt {
  padding: 0;
  text-align: left;
}
</style>